import { memo, ReactNode } from 'react';
import NextImage from 'next/image';
import styled from 'styled-components';
import cx from 'classnames';

import ListPriceAside from './ListPriceAside';
import { device } from 'styles/breakpoints';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import Text from 'components/common/text';
import { changeStep } from 'store/slices/onboarding';
import { onboardingSelector } from 'store/slices/onboarding/selector';

type ListPriceTemplateProps = {
  children: ReactNode;
  lastStep?: boolean;
};

function ListPriceTemplate({ children, lastStep }: ListPriceTemplateProps) {
  const dispatch = useAppDispatch();
  const { step } = useAppSelector(onboardingSelector);

  function handleStepChange() {
    dispatch(changeStep(step === 'stepConfirm' ? 'stepListPrice' : 'stepUser'));
  }

  return (
    <ListPriceTemplateWrapper>
      <ListPriceAside />
      <div className={cx('listing-box', { alt: lastStep })}>
        <div className="listing-box-google">
          <NextImage
            src="/static/icons/google-mark.svg"
            width={85}
            height={120}
          />
        </div>
        {step !== 'stepUser' && (
          <div className="listing-box-back" onClick={handleStepChange}>
            <NextImage
              src="/static/icons/arrow-left.svg"
              width={24}
              height={24}
            />
            <Text> Back </Text>
          </div>
        )}

        {children}
      </div>
    </ListPriceTemplateWrapper>
  );
}

const ListPriceTemplateWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 24px;
  transition: all 200ms ease;
  .listing-box {
    margin-left: 36px;
    padding: 70px 120px;
    background-color: ${({ theme }) => theme.colors.white};
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 688px;
    &-google {
      position: absolute;
      left: 36px;
      top: -1px;
      z-index: 2;
    }
    &.alt {
      padding: 48px 32px;
    }
    &-back {
      cursor: pointer;
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 2;
      right: 24px;
      top: 24px;
      > p {
        margin-left: 4px;
      }
    }
  }
  @media ${device.smallLaptop} {
    flex-direction: column-reverse;
    padding: 0;
    .listing-box {
      margin-left: 0;
      max-width: 100%;
      padding: 48px 32px;
      text-align: center;
      &-google {
        left: 24px;
        img {
          height: 80px !important;
          width: 80px !important;
        }
      }
    }
  }
`;

export default memo(ListPriceTemplate);
